/**
 * BlaSirkelIcon — blå roterende sirkel som vises i sidebaren
 * når en agent aktivt kjører (agentStatus === 'running' / 'planning').
 * Bruker CSS-animasjon via inline <style> slik at ingen ekstra CSS-fil trengs.
 */
interface BlaSirkelIconProps {
  size?: number
}

export function BlaSirkelIcon({ size = 18 }: BlaSirkelIconProps) {
  return (
    <>
      <style>{`
        @keyframes bla-sirkel-spin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
        .bla-sirkel-spin {
          animation: bla-sirkel-spin 1.1s linear infinite;
          transform-origin: center;
          display: inline-flex;
        }
      `}</style>
      <span className="bla-sirkel-spin" style={{ width: size, height: size, display: 'inline-flex' }}>
        <svg
          width={size}
          height={size}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Background track */}
          <circle
            cx="8" cy="8" r="6.5"
            stroke="#1A93FE"
            strokeOpacity="0.2"
            strokeWidth="1.5"
            fill="none"
          />
          {/* Spinning arc — 270° arc from top, going clockwise */}
          <path
            d="M8 1.5 A6.5 6.5 0 1 1 1.5 8"
            stroke="#1A93FE"
            strokeWidth="1.5"
            strokeLinecap="round"
            fill="none"
          />
        </svg>
      </span>
    </>
  )
}
